import script from "./MessageAttachments.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageAttachments.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QList,QItem,QItemLabel});
